import styled from "@emotion/styled/macro";
import { withProps } from "recompose";
import POI from "../../../assets/images/POI.svg";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
const LogoIcon = withProps({ src: POI })(styled.img`
  height: 2.5em;
`);
const LogoWrapper = styled.div`
  align-items: center;
  width: 100%;
  justify-content: center;
  display: flex;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: initial;
    margin: 0.15em 1em 0.8em 1em;
  }
`;

const LogoText = styled.p`
  font-family: ${({ theme }) => theme.fonts.heading};
  color: #29a737;
  padding-top: 0.5em;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-top: 0.4em;
    font-size: 1.25em;
  }
`;

const Logo = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const handleClickRefresh = () => {
    if (location.pathname === "/check") {
      window.location.reload();
    }
  };
  return (
    <NavLink to="/check">
      <LogoWrapper onClick={() => handleClickRefresh()}>
        <LogoIcon />
        <LogoText>{t("title")}</LogoText>
      </LogoWrapper>
    </NavLink>
  );
};

export default Logo;
